import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/whatsapp-chatbot-contacts';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const whatsappChatbotContactService = {
  list: async (params = {}) => {
    const response = await apiClient.get(BASE, { params });
    const data = unwrap(response.data);
    return {
      contacts: data?.contacts ?? [],
      pagination: data?.pagination ?? null,
    };
  },

  create: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return response.data;
  },

  update: async (uuid, payload) => {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response.data;
  },

  remove: async (uuid) => {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response.data;
  },
};

export default whatsappChatbotContactService;
